import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetGeneratedOrdersSlice = createSlice({
    name: "getGeneratedOrders",
    initialState,
    reducers: {
        getGeneratedOrdersRequest(state) {
            state.loading = true;
        },
        getGeneratedOrdersRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getGeneratedOrdersRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getGeneratedOrdersRequest,
    getGeneratedOrdersRequestSuccess,
    getGeneratedOrdersRequestError,
} = GetGeneratedOrdersSlice.actions;

export default GetGeneratedOrdersSlice.reducer;
